import React from 'react';
import ExpandableListItem from '../../../../components/molecules/expandable_element';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import useStyles from './styles';
import FilterForm from './filter_form';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from '../../configuration';

interface IProps {
  vat_num: string | null;
  period: string | null;
  year: string | null;
  declaration_status: string | null;
  vat_return_state: string | null;
}

const Filter = (props: IProps) => {
  const classes = useStyles();

  const Header = () => {
    return (
      <div className={classes.filter_header}>
        <SearchIcon style={{ marginRight: '1rem' }} />
        <span style={{ fontSize: '1.2rem' }}>
          <TranslatedText textMap={Translations.search} />
        </span>
      </div>
    );
  };

  const Body = () => {
    return (
      <FilterForm
        vat_num={props.vat_num}
        period={props.period}
        year={props.year}
        declaration_status={props.declaration_status}
        vat_return_state={props.vat_return_state}
      />
    );
  };

  return (
    <div
      className={clsx({
        [classes.cardLayout]: true,
        [classes.filter]: true,
      })}
    >
      <ExpandableListItem
        renderDataHeader={() => <Header />}
        renderDataBody={() => <Body />}
      />
    </div>
  );
};

export default Filter;
